import { render, staticRenderFns } from "./ServiceCosmetologistLayout.vue?vue&type=template&id=76249a94&scoped=true"
import script from "./ServiceCosmetologistLayout.vue?vue&type=script&lang=ts"
export * from "./ServiceCosmetologistLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76249a94",
  null
  
)

export default component.exports